import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { compact, orderBy, range, uniq } from 'lodash-es';
import { FIRST_STANFORD_TAX_YEAR, isStanfordTaxReturnType, StanfordTaxReturnType } from '~/models/ServiceIntegrations';
import { calendarYearIn } from '~/utils/date-timezone.utils';
const STANFORD_TAX_TIME_ZONE = 'America/New_York';
export const stanfordTaxReturnTypeTextsPath = 'integrations.setup.stanfordTax.returnTypes';
export const stanfordTaxYearOptions = (now, storedYear)=>orderBy(uniq(compact([
        storedYear,
        ...range(calendarYearIn(now, STANFORD_TAX_TIME_ZONE) + 1, FIRST_STANFORD_TAX_YEAR - 1, -1)
    ])), [], [
        'desc'
    ]);
export const defaultStanfordTaxYear = (now)=>calendarYearIn(now, STANFORD_TAX_TIME_ZONE) - 1;
export const editStanfordTaxMapping = (param)=>{
    let { mapping, edit, now } = param;
    var _ref;
    if ('taxYear' in edit) return mapping && _object_spread_props(_object_spread({}, mapping), {
        taxYear: edit.taxYear
    });
    if (!isStanfordTaxReturnType(edit.returnType)) return undefined;
    return {
        returnType: edit.returnType,
        taxYear: (_ref = mapping === null || mapping === void 0 ? void 0 : mapping.taxYear) !== null && _ref !== void 0 ? _ref : defaultStanfordTaxYear(now)
    };
};
export const stanfordTaxReturnTypeOptions = (texts)=>[
        {
            value: StanfordTaxReturnType.Individual,
            label: texts.individual()
        },
        {
            value: StanfordTaxReturnType.CCorporation,
            label: texts.cCorporation()
        },
        {
            value: StanfordTaxReturnType.SCorporation,
            label: texts.sCorporation()
        },
        {
            value: StanfordTaxReturnType.Partnership,
            label: texts.partnership()
        }
    ];
